export default {
  index: [
    {
      path: '/AnalyzeReprot',
      component: resolve => require(['./AnalyzeReprotIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/AnalyzeReport/_router.js